/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my text uploaded anywhere?`)
};

const es_rv_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se carga mi texto en algún lugar?`)
};

const de_rv_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird mein Text irgendwohin hochgeladen?`)
};

const nl_rv_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt mijn tekst ergens geüpload?`)
};

const fr_rv_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon texte est-il téléchargé quelque part ?`)
};

const it_rv_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mio testo viene caricato da qualche parte?`)
};

const pt_br2_rv_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu texto é enviado para algum lugar?`)
};

const pt_rv_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu texto é enviado para algum lugar?`)
};

const ja_rv_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私のテキストはアップロードされますか?`)
};

const zh_rv_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的文本会被上传吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_faq3_q", locale)
	if (locale === "en") return en_rv_faq3_q(inputs)
	if (locale === "es") return es_rv_faq3_q(inputs)
	if (locale === "de") return de_rv_faq3_q(inputs)
	if (locale === "nl") return nl_rv_faq3_q(inputs)
	if (locale === "fr") return fr_rv_faq3_q(inputs)
	if (locale === "it") return it_rv_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_rv_faq3_q(inputs)
	if (locale === "pt") return pt_rv_faq3_q(inputs)
	if (locale === "ja") return ja_rv_faq3_q(inputs)
	return zh_rv_faq3_q(inputs)
};